// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "../src/assets/scripts/classList"
import "babel-polyfill";
import "./assets/scripts/smoothScroll"
import Vue from 'vue'
import App from './App'
import router from './router'
import VueScrollReveal from 'vue-scroll-reveal';
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import Axios from "axios";
import moment from 'moment'

Vue.config.productionTip = false

Vue.prototype.$http = Axios


Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY')
  }
})

Vue.use(VueScrollReveal);
Vue.use(VueChartkick, {
  adapter: Chart
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCsriRRB7tlb5Tyt_zLYBajJB54p2mwVeE',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.prototype.$eventHub = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js